/**
 * Creates a click handler that smooth-scrolls to a target element by ID.
 *
 * Prevents default anchor behavior and uses the native scrollIntoView API.
 */
export function smoothScrollTo(targetId: string) {
  return (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
  };
}

/**
 * Strips the leading '#' from an anchor target string.
 */
export function targetToId(target: string): string {
  return target.replace('#', '');
}
